
window.initCheckValidation = function (item){
    const checkboxForm = item.closest('form');
    const submitButton = checkboxForm.querySelector('button[type="submit"]');
    submitButton.setAttribute('disabled', true);

    document.addEventListener('change', (e) => {
      const target = e.target;
      if (target.hasAttribute('data-checkbox')) {
        const checkbox = target;
        const form = checkbox.closest('form');
        let actionButton = form.querySelector('button[type="submit"]');
        
        if (checkbox.checked) {
          actionButton.removeAttribute('disabled', false)
        } else {
          actionButton.setAttribute('disabled', true)
        }
      }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-checkbox="validation"]').forEach(window.initCheckValidation)
})